module.exports = __webpack_public_path__ + "static/img/萌唐唐诗会2.a68f6177.png";